var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#AD9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99914 8.52026C6.55906 8.52026 6.19897 8.19144 6.19897 7.78958V3.58827C6.19897 3.18641 6.55906 2.8576 6.99914 2.8576C7.43922 2.8576 7.79925 3.18641 7.79925 3.58827V7.78958C7.79925 8.19144 7.43922 8.52026 6.99914 8.52026Z",
    fill: "#FDFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 11.6094C6.44753 11.6094 5.99976 11.126 5.99976 10.5298C5.99976 9.93357 6.44753 9.45026 6.99992 9.45026C7.55225 9.45026 8.00008 9.93357 8.00008 10.5298C8.00008 11.126 7.55225 11.6094 6.99992 11.6094Z",
    fill: "#FDFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.cb8badccfcc46adcb0c5a7bbac7fe0a1.svg";
export { ForwardRef as ReactComponent };